import "./DataFieldTemplateSelector.less";

import { Checkbox, Modal, Spin } from "antd";
import React from "react";

import { DataFieldApi } from "lib/api";
import { CancellationToken } from "lib/api/base";
import { DataFieldTemplate } from "lib/data/model";
import { DataField } from "lib/data/model";
import { Requiredness } from "lib/data/model/enumerations";
import { StateService } from "lib/services";

import { AddNewButton, DeleteButton } from "components/general/StandardButtons";
import { SortableContainer } from "../../components/TemplateRequirementSelector/SortableContainer";
import { SortableItem } from "../../components/TemplateRequirementSelector/SortableItem";

interface IDataFieldTemplateSelectorProps {
	dataFieldTemplates?: DataFieldTemplate[];
	awaitingUpdate: boolean;
	softUpdate(): void;
	addDataFieldTemplate(dataFieldTemplate: DataFieldTemplate, callback: Function): void;
	removeDataFieldTemplate(dataFieldTemplate: DataFieldTemplate): void;
	moveDataFieldTemplate(oldIndex: number, newIndex: number): void;
}
interface IDataFieldTemplateSelectorState {
	newDataFieldModal: boolean;
	dataFields: DataField[];
}

export class DataFieldTemplateSelector extends React.Component<IDataFieldTemplateSelectorProps, IDataFieldTemplateSelectorState> {

	private apiCancellationToken: CancellationToken = new CancellationToken();

	constructor(props: IDataFieldTemplateSelectorProps) {
		super(props);
		this.state = {
			newDataFieldModal: false,
			dataFields: []
		}
	}

	public componentWillMount = async () => {
		const dataFields: DataField[] = await DataFieldApi.getDataFields();
		dataFields.sort((a, b) => {
			const nameA = a.name;
			const nameB = b.name;
			return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0;
		});
		StateService.setCancelableState(() => this.setState({ dataFields }), this.apiCancellationToken);
	}

	public componentWillUnmount() {

		// Cancel Outstanding API Calls
		this.apiCancellationToken.cancel();
	}

	newDataFieldModalClose = () => {
		if (!this.props.awaitingUpdate) {
			StateService.setCancelableState(() => this.setState({ newDataFieldModal: false }), this.apiCancellationToken);
		}
	}
	newDataFieldModalOpen = () => {
		StateService.setCancelableState(() => this.setState({ newDataFieldModal: true }), this.apiCancellationToken);
	}
	addNewDataFieldTemplate = (dataField: DataField) => {
		const dataFieldTemplate = new DataFieldTemplate();
		dataFieldTemplate.name = dataField.name;
		dataFieldTemplate.stringAppendage = "";
		dataFieldTemplate.stringPrefix = "";
		dataFieldTemplate.field = dataField;
		this.props.addDataFieldTemplate(dataFieldTemplate, this.newDataFieldModalClose);
	}

	public getCheckboxRequirement = (dataFieldTemplate: DataFieldTemplate) => {
		let value: boolean;
		if (dataFieldTemplate.getParent) {
			value = dataFieldTemplate.getParent().requiredness === Requiredness.REQUIRED;
		} else {
			value = false;
		}
		return value;
	}

	public changeCheckbox = (dataFieldTemplate: DataFieldTemplate) => {
		if (dataFieldTemplate.getParent) {
			if (dataFieldTemplate.getParent().requiredness === Requiredness.REQUIRED) {
				dataFieldTemplate.getParent().requiredness = Requiredness.OPTIONAL;
				this.props.softUpdate();
			} else {
				dataFieldTemplate.getParent().requiredness = Requiredness.REQUIRED;
				this.props.softUpdate();
			}
		}
	}

	render() {
		if (this.props.dataFieldTemplates) {
			return (
				<div>

					<SortableContainer onSortEnd={({ oldIndex, newIndex }: any) => { this.props.moveDataFieldTemplate(oldIndex, newIndex) }} axis="xy" className="field-template-container">
						<div className="field-template new-field-template">
							<div className="field-template-title">New Field</div>
							<AddNewButton onClick={this.newDataFieldModalOpen} />
							<Modal className="new-field-template-modal" visible={this.state.newDataFieldModal} onCancel={this.newDataFieldModalClose} footer={[]}>
								{this.props.awaitingUpdate ?
									<Spin />
									:
									<div className="new-field-templates">
										{this.state.dataFields.map((dataField, key) =>
											<div onClick={() => this.addNewDataFieldTemplate(dataField)} key={key} className="field-template">
												{dataField.name}
											</div>)}
									</div>
								}
							</Modal>
						</div>
						{
							this.props.dataFieldTemplates.map((dataFieldTemplate, key) => {
								return (
									<SortableItem className="" index={key} key={key}>
										<div key={key} className="field-template">
											<div className="field-template-title">{dataFieldTemplate.field.name}</div>
											<DeleteButton onClick={() => this.props.removeDataFieldTemplate(dataFieldTemplate)} />
											<div className="field-template-checkbox">
												Required<Checkbox onChange={() => this.changeCheckbox(dataFieldTemplate)} checked={this.getCheckboxRequirement(dataFieldTemplate)} />
											</div>
										</div>
									</SortableItem>
								)
							})
						}
					</SortableContainer>
				</div >
			)
		}
		return (
			<div className="field-template-container">
				<Spin />
			</div>
		)
	}
}
